var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/no-unknown-property */
import Heading from '@marketing/components/global/typography/Heading';
import { Helmet } from 'react-helmet-async';
import './price_spider.css';
function ProductFinder() {
    return (_jsxs("div", __assign({ className: "flex flex-col gap-xl-m md:gap-[30px] items-center bg-surface-white px-2xs-gutter py-sm-gutter md:px-2xl-gutter md:py-[60px]" }, { children: [_jsxs(Helmet, { children: [_jsx("meta", { name: "ps-key", content: "1711-65e2256311e8c0310338432d" }), _jsx("meta", { name: "ps-country", content: "US" }), _jsx("meta", { name: "ps-language", content: "en" }), _jsx("script", { src: "//cdn.pricespider.com/1/lib/ps-widget.js", async: true })] }), _jsx(Heading, __assign({ size: "md" }, { children: "Try a Variety of Recipes" })), _jsx("div", __assign({ className: "container-ps-widget rounded-[24px]" }, { children: _jsx("div", { className: "ps-widget ps-65e2256311e8c0310338432d", "ps-sku": "Beef Mash", "ps-widget-type": "embedded" }) }))] })));
}
export default ProductFinder;
